<mat-form-field style="width: 100%">
  <input #input matInput
    [matDatepicker]="dobPicker"
    [placeholder]="placeholder"
    (click)="dobPicker.open()"
    [(ngModel)]="date"
    (ngModelChange)="change()"
    [required]="required"
    [readonly]="readOnly"
    (keypress)="onKeyPress($event)"
     [disabled]="disabled"
    [min]="min"
    [max]="max">
  <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
  <mat-datepicker #dobPicker [disabled]="readOnly || disabled"></mat-datepicker>
</mat-form-field>
